//Module
export * from './shared-components.module'



export * from './ui-search/ui-search.component'
export * from './ui-multirow-basic/ui-multirow-basic.component'
export * from './ui-address-ind/ui-address-ind.component'
export * from './policy-search/policy-search.component'
export * from './police-details/police-details.component'
export * from './occupation-capture/occupation-capture.component'
export * from './new-client-capture/new-client-capture.component'
export * from './insured-details/insured-details.component'
export * from './identity-capture/identity-capture.component'
export * from './hospital-details/hospital-details.component'
export * from './generic-zero-ui/generic-zero-ui.component'
export * from './generic-search/generic-search.component'
export * from './field-specific-components/nz-explain-wrapper/nz-explain-wrapper.component'
export * from './doctor-details/doctor-details.component'
export * from './coverages/coverages.component'
export * from './contactnumber-capture/contactnumber-capture.component'
export * from './client-search/client-search.component'
export * from './claims-basic-details/claims-basic-details.component'
export * from './captured-policy-list/captured-policy-list.component'
export * from './bank-details/bank-details.component'
export * from './address-capture-indonesia/address-capture-indonesia.component'